'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Checkbox } from '@common/components';
import { SvgChevrondown } from '@common/icon';
import { cn } from '@core/utils';
import { useState } from 'react';
import { TERM_CATEGORY } from '@/api/types/parent-code';
import { useGlobalStore } from '@/stores/GlobalStore';
interface AgreementSectionProps {
  onNext?: () => void;
  onClose?: () => void;
}
export const AgreementSection = t0 => {
  const $ = _c(102);
  const {
    onNext,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      welloTerms: false,
      privacyCollection: false,
      thirdPartyInfo: false,
      membershipTerms: false,
      addressVerification: false,
      shippingInfo: false,
      voluntaryDonation: false,
      refundPolicy: false,
      giftInfo: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [agreements, setAgreements] = useState(t1);
  const [isThirdPartyExpanded, setIsThirdPartyExpanded] = useState(false);
  const setTermsDrawerType = useGlobalStore(_temp);
  let t2;
  if ($[1] !== setTermsDrawerType) {
    t2 = termType => {
      setTermsDrawerType(termType);
    };
    $[1] = setTermsDrawerType;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleTermsView = t2;
  const requiredAgreements = ["welloTerms", "privacyCollection", "thirdPartyInfo", "membershipTerms", "addressVerification", "shippingInfo", "voluntaryDonation", "refundPolicy", "giftInfo"] as const;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["membershipTerms", "addressVerification", "shippingInfo"];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const thirdPartySubItems = t3 as const;
  const isAgreementAll = requiredAgreements.every(key => agreements[key]);
  const isThirdPartyAllChecked = thirdPartySubItems.every(key_0 => agreements[key_0]);
  let t4;
  if ($[4] !== isAgreementAll) {
    t4 = () => {
      const newValue = !isAgreementAll;
      setAgreements({
        welloTerms: newValue,
        privacyCollection: newValue,
        thirdPartyInfo: newValue,
        membershipTerms: newValue,
        addressVerification: newValue,
        shippingInfo: newValue,
        voluntaryDonation: newValue,
        refundPolicy: newValue,
        giftInfo: newValue
      });
    };
    $[4] = isAgreementAll;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const toggleAllAgreements = t4;
  let t5;
  if ($[6] !== agreements) {
    t5 = (key_1, checked) => {
      const newAgreements = {
        ...agreements,
        [key_1]: checked
      };
      if (key_1 === "thirdPartyInfo") {
        thirdPartySubItems.forEach(subKey => {
          newAgreements[subKey] = checked;
        });
      }
      if (thirdPartySubItems.includes(key_1 as (typeof thirdPartySubItems)[number])) {
        const allSubItemsChecked = thirdPartySubItems.every(subKey_0 => subKey_0 === key_1 ? checked : newAgreements[subKey_0]);
        newAgreements.thirdPartyInfo = allSubItemsChecked;
      }
      setAgreements(newAgreements);
    };
    $[6] = agreements;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const updateAgreement = t5;
  let t6;
  if ($[8] !== isThirdPartyExpanded) {
    t6 = () => {
      setIsThirdPartyExpanded(!isThirdPartyExpanded);
    };
    $[8] = isThirdPartyExpanded;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const toggleThirdPartyAccordion = t6;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className={cn("mb-32 text-start text-Gray-700 typo-body3", "mobile-tablet:mb-16 mobile-tablet:typo-body4")}>이용약관에 동의해주세요.</p>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== isAgreementAll || $[12] !== toggleAllAgreements) {
    t8 = <div className="mb-16 rounded-xsmall bg-Gray-100 px-12 py-8"><Checkbox className="font-600" checked={isAgreementAll} onCheckedChange={toggleAllAgreements}>전체 동의</Checkbox></div>;
    $[11] = isAgreementAll;
    $[12] = toggleAllAgreements;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== updateAgreement) {
    t9 = checked_0 => updateAgreement("welloTerms", checked_0);
    $[14] = updateAgreement;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="flex items-start gap-4"><span className="font-500 text-Gray-black typo-body4">(필수)</span><span className="font-400 text-Gray-800 typo-body4">웰로 고향사랑기부제 이용약관</span></div>;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== handleTermsView) {
    t11 = <div className="flex flex-1 items-start justify-between gap-4">{t10}<button className="font-600 underline typo-body4" type="button" onClick={e => {
        e.stopPropagation();
        handleTermsView(TERM_CATEGORY.GOHYANG_LOVE_DONATION_TERMS);
      }}>보기</button></div>;
    $[17] = handleTermsView;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== agreements.welloTerms || $[20] !== t11 || $[21] !== t9) {
    t12 = <Checkbox checked={agreements.welloTerms} onCheckedChange={t9} className="justify-between">{t11}</Checkbox>;
    $[19] = agreements.welloTerms;
    $[20] = t11;
    $[21] = t9;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== updateAgreement) {
    t13 = checked_1 => updateAgreement("privacyCollection", checked_1);
    $[23] = updateAgreement;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="flex items-start gap-4"><span className="font-500 text-Gray-black typo-body4">(필수)</span><span className="font-400 text-Gray-800 typo-body4">개인정보 수집이용 동의</span></div>;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== handleTermsView) {
    t15 = <div className="flex flex-1 items-start justify-between gap-4">{t14}<button className="font-600 underline typo-body4" type="button" onClick={e_0 => {
        e_0.stopPropagation();
        handleTermsView(TERM_CATEGORY.PERSONAL_INFO_COLLECTION_AGREEMENT);
      }}>보기</button></div>;
    $[26] = handleTermsView;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== agreements.privacyCollection || $[29] !== t13 || $[30] !== t15) {
    t16 = <Checkbox checked={agreements.privacyCollection} onCheckedChange={t13} className="justify-between">{t15}</Checkbox>;
    $[28] = agreements.privacyCollection;
    $[29] = t13;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== updateAgreement) {
    t17 = checked_2 => updateAgreement("thirdPartyInfo", checked_2);
    $[32] = updateAgreement;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <span className="font-500 text-Gray-black typo-body4">(필수)</span>;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== toggleThirdPartyAccordion) {
    t19 = e_1 => {
      e_1.preventDefault();
      toggleThirdPartyAccordion();
    };
    $[35] = toggleThirdPartyAccordion;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <span className="text-start">고향사랑e음 회원가입 및 연계를 위한 개인정보 제3자 제공 동의</span>;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== isThirdPartyExpanded) {
    t21 = cn("size-16 min-h-21 min-w-16 transition-transform duration-200", {
      "rotate-180": isThirdPartyExpanded
    });
    $[38] = isThirdPartyExpanded;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== t21) {
    t22 = <SvgChevrondown className={t21} />;
    $[40] = t21;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== t19 || $[43] !== t22) {
    t23 = <div className="flex flex-1 items-start justify-between gap-4"><div className="flex items-start gap-4">{t18}<span className="flex cursor-pointer items-start gap-4 font-400 text-Gray-800 typo-body4" onClick={t19}>{t20}{t22}</span></div></div>;
    $[42] = t19;
    $[43] = t22;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== isThirdPartyAllChecked || $[46] !== t17 || $[47] !== t23) {
    t24 = <Checkbox checked={isThirdPartyAllChecked} onCheckedChange={t17} className="justify-between">{t23}</Checkbox>;
    $[45] = isThirdPartyAllChecked;
    $[46] = t17;
    $[47] = t23;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== agreements.addressVerification || $[50] !== agreements.membershipTerms || $[51] !== agreements.shippingInfo || $[52] !== handleTermsView || $[53] !== isThirdPartyExpanded || $[54] !== updateAgreement) {
    t25 = isThirdPartyExpanded && <div className="flex flex-col pl-16"><Checkbox checked={agreements.membershipTerms} onCheckedChange={checked_3 => updateAgreement("membershipTerms", checked_3)} className="justify-between"><div className="flex flex-1 items-start justify-between gap-4"><span className="font-400 text-Gray-800 typo-body4">고향사랑e음 회원가입을 위한 개인정보 제공 동의</span><button className="font-600 underline typo-body4" type="button" onClick={e_2 => {
            e_2.stopPropagation();
            handleTermsView(TERM_CATEGORY.GOHYANG_EUM_SIGNUP_THIRD_PARTY_AGREEMENT);
          }}>보기</button></div></Checkbox><Checkbox checked={agreements.addressVerification} onCheckedChange={checked_4 => updateAgreement("addressVerification", checked_4)} className="justify-between"><div className="flex flex-1 items-start justify-between gap-4"><span className="font-400 text-Gray-800 typo-body4">주소지 확인을 위한 주민등록번호 제공 동의</span><button className="font-600 underline typo-body4" type="button" onClick={e_3 => {
            e_3.stopPropagation();
            handleTermsView(TERM_CATEGORY.RESIDENT_REGISTRATION_PROVIDE_AGREEMENT);
          }}>보기</button></div></Checkbox><Checkbox checked={agreements.shippingInfo} onCheckedChange={checked_5 => updateAgreement("shippingInfo", checked_5)} className="justify-between"><div className="flex flex-1 items-start justify-between gap-4"><span className="font-400 text-Gray-800 typo-body4">답례품 배송 관련 개인정보 제3자 제공 동의</span><button className="font-600 underline typo-body4" type="button" onClick={e_4 => {
            e_4.stopPropagation();
            handleTermsView(TERM_CATEGORY.GIFT_DELIVERY_THIRD_PARTY_AGREEMENT);
          }}>보기</button></div></Checkbox></div>;
    $[49] = agreements.addressVerification;
    $[50] = agreements.membershipTerms;
    $[51] = agreements.shippingInfo;
    $[52] = handleTermsView;
    $[53] = isThirdPartyExpanded;
    $[54] = updateAgreement;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  let t26;
  if ($[56] !== t24 || $[57] !== t25) {
    t26 = <div className="flex flex-col gap-8">{t24}{t25}</div>;
    $[56] = t24;
    $[57] = t25;
    $[58] = t26;
  } else {
    t26 = $[58];
  }
  let t27;
  if ($[59] !== updateAgreement) {
    t27 = checked_6 => updateAgreement("voluntaryDonation", checked_6);
    $[59] = updateAgreement;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  let t28;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <span className="flex gap-4"><span className="font-500 text-Gray-black typo-body4">(필수)</span><span className="font-400 text-Gray-800 typo-body4">공무 관련 강요 없이 자발적으로 기부합니다.</span></span>;
    $[61] = t28;
  } else {
    t28 = $[61];
  }
  let t29;
  if ($[62] !== handleTermsView) {
    t29 = <div className="flex flex-1 items-start justify-between gap-4">{t28}<button className="font-600 underline typo-body4" type="button" onClick={e_5 => {
        e_5.stopPropagation();
        handleTermsView(TERM_CATEGORY.TERMS_GOVERNMENT_PRESSURE);
      }}>보기</button></div>;
    $[62] = handleTermsView;
    $[63] = t29;
  } else {
    t29 = $[63];
  }
  let t30;
  if ($[64] !== agreements.voluntaryDonation || $[65] !== t27 || $[66] !== t29) {
    t30 = <Checkbox checked={agreements.voluntaryDonation} onCheckedChange={t27} className="justify-between">{t29}</Checkbox>;
    $[64] = agreements.voluntaryDonation;
    $[65] = t27;
    $[66] = t29;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  let t31;
  if ($[68] !== updateAgreement) {
    t31 = checked_7 => updateAgreement("refundPolicy", checked_7);
    $[68] = updateAgreement;
    $[69] = t31;
  } else {
    t31 = $[69];
  }
  let t32;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <span className="flex gap-4"><span className="font-500 text-Gray-black typo-body4">(필수)</span><span className="font-400 text-Gray-800 typo-body4">안내사항(환불 불가·세액공제 등)을 확인했습니다.</span></span>;
    $[70] = t32;
  } else {
    t32 = $[70];
  }
  let t33;
  if ($[71] !== handleTermsView) {
    t33 = <div className="flex flex-1 items-start justify-between gap-4">{t32}<button className="font-600 underline typo-body4" type="button" onClick={e_6 => {
        e_6.stopPropagation();
        handleTermsView(TERM_CATEGORY.TERMS_GUIDANCE_NOTICE);
      }}>보기</button></div>;
    $[71] = handleTermsView;
    $[72] = t33;
  } else {
    t33 = $[72];
  }
  let t34;
  if ($[73] !== agreements.refundPolicy || $[74] !== t31 || $[75] !== t33) {
    t34 = <Checkbox checked={agreements.refundPolicy} onCheckedChange={t31} className="justify-between">{t33}</Checkbox>;
    $[73] = agreements.refundPolicy;
    $[74] = t31;
    $[75] = t33;
    $[76] = t34;
  } else {
    t34 = $[76];
  }
  let t35;
  if ($[77] !== updateAgreement) {
    t35 = checked_8 => updateAgreement("giftInfo", checked_8);
    $[77] = updateAgreement;
    $[78] = t35;
  } else {
    t35 = $[78];
  }
  let t36;
  if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <span className="flex gap-4"><span className="font-500 text-Gray-black typo-body4">(필수)</span><span className="font-400 text-Gray-800 typo-body4">답례품 정보 확인 및 동의</span></span>;
    $[79] = t36;
  } else {
    t36 = $[79];
  }
  let t37;
  if ($[80] !== handleTermsView) {
    t37 = <div className="flex flex-1 items-start justify-between gap-4">{t36}<button className="font-600 underline typo-body4" type="button" onClick={e_7 => {
        e_7.stopPropagation();
        handleTermsView(TERM_CATEGORY.TERMS_GIFT_INFO_CHECK_AGREEMENT);
      }}>보기</button></div>;
    $[80] = handleTermsView;
    $[81] = t37;
  } else {
    t37 = $[81];
  }
  let t38;
  if ($[82] !== agreements.giftInfo || $[83] !== t35 || $[84] !== t37) {
    t38 = <Checkbox checked={agreements.giftInfo} onCheckedChange={t35} className="justify-between">{t37}</Checkbox>;
    $[82] = agreements.giftInfo;
    $[83] = t35;
    $[84] = t37;
    $[85] = t38;
  } else {
    t38 = $[85];
  }
  let t39;
  if ($[86] !== t12 || $[87] !== t16 || $[88] !== t26 || $[89] !== t30 || $[90] !== t34 || $[91] !== t38) {
    t39 = <div className="mb-32 flex flex-col">{t12}{t16}{t26}{t30}{t34}{t38}</div>;
    $[86] = t12;
    $[87] = t16;
    $[88] = t26;
    $[89] = t30;
    $[90] = t34;
    $[91] = t38;
    $[92] = t39;
  } else {
    t39 = $[92];
  }
  let t40;
  if ($[93] !== isAgreementAll || $[94] !== onClose || $[95] !== onNext || $[96] !== toggleAllAgreements) {
    t40 = isAgreementAll ? <Button className="w-full" onClick={() => {
      onNext?.();
      onClose?.();
    }}>기부하기</Button> : <Button theme="sub-fill" className="w-full" onClick={toggleAllAgreements}>전체 동의하기</Button>;
    $[93] = isAgreementAll;
    $[94] = onClose;
    $[95] = onNext;
    $[96] = toggleAllAgreements;
    $[97] = t40;
  } else {
    t40 = $[97];
  }
  let t41;
  if ($[98] !== t39 || $[99] !== t40 || $[100] !== t8) {
    t41 = <div className="flex flex-col">{t7}{t8}{t39}{t40}</div>;
    $[98] = t39;
    $[99] = t40;
    $[100] = t8;
    $[101] = t41;
  } else {
    t41 = $[101];
  }
  return t41;
};
function _temp(state) {
  return state.setTermsDrawerType;
}